import { Component, Input, Output, EventEmitter, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EllipsisPipe } from '@sbd-doug-frontend/shared/lib/public-pipes';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';

@Component({
  selector: 'accordion-quote-request-view',
  templateUrl: './accordion-quote-request-view.component.html',
  styleUrls: ['./accordion-quote-request-view.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRadioModule,
    MatDividerModule,
    MatCardModule,
    MatTooltipModule,
    EllipsisPipe,
  ],
  standalone: true,
  viewProviders: [MatExpansionPanel]
})

export class AccordionQuoteRequestViewComponent implements OnInit {
  _fuseMediaWatcherService = inject(FuseMediaWatcherService);
  _formBuilder = inject(FormBuilder)

  @Input() item: any;
  @Input() displayMode: QuoteRequestViewDisplayMode = 'wrapped' ;
  @Input() isExpanded: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() showDeliveryOption: boolean = false;
  @Input() menuItems: any[] = [];

  @Output() panelStateChange = new EventEmitter<boolean>();
  @Output() closeDrawer = new EventEmitter<void>();
  @Output() fileClicked = new EventEmitter<any>();
  @Output() menuClicked = new EventEmitter<any>();
  @Output() quoteUpdated = new EventEmitter<any>();

  isScreenSmall: boolean = false;
  _unsubscribeAll: Subject<void> = new Subject<void>();

  readonly panelOpenState = signal(false);

  ngOnInit() {
    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    this.item.quote_selection_form = this._formBuilder.group({
      selected_quote_option: [this.item.selected_quote?.premium ?? 0],
    });
  }

  getDurationTerm(data: any) {
    if (Object.keys(data).filter(k => k === 'selected_quote').length > 0) {
      return data?.selected_quote?.duration + '-' + data?.selected_quote?.duration_units + ' Term';
    } else {
      if (data?.duration === undefined) {
        return 'Not defined';
      }
      return data?.duration + '-' + data?.duration_units + ' Term';
    }
  }

  protected readonly isNaN = isNaN;

  onMenuClick(menuItem: any) {
    this.menuClicked.emit(menuItem);
  }

  getFormattedAddress(address: any): string {
    return `${address?.street_1}${address?.street_2 ? ', ' + address?.street_2 : ''}, ${address?.city}, ${address?.state_abbreviation} ${address?.zip}`;
  }

  onFileClick(file: any) {
    this.fileClicked.emit({
      quoteRequestId: this.item.quote_request_id,
      file_id: file.file_id
    });
  }

  onQuoteChange() {
    const selectedQuote = this.item?.quote_request_bond?.quotes.findIndex((q, i) => q.premium === this.item.quote_selection_form.get('selected_quote_option').value);
    this.item.selected_quote = this.item.quote_request_bond.quotes[selectedQuote];
    this.quoteUpdated.emit(this.item);
  }



}


export type QuoteRequestViewDisplayMode = 'wrapped' | 'full';
